import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Modal, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/ProfessionalAdvancementForm.css";

const ProfessionalAdvancementForm = () => {
  const navigate = useNavigate();

  const courseOptions = [
    "Fellowships in Advanced Occupational Therapy - 36 Weeks- Part 1 & 3 Online & Part 2 Offline",
    "Physical Agent Modalities adjunct to Occupational Therapy -3 full day course - Offline only",
    "Ergonimcs - Office , School & Home - 3 full day course - Hybrid",
    "Driver Rehab - 2 full day course - Offline only",
    "Wheelchair Seating & Mobility- 1 day course - Offline",
    "SLD certification course - 1 day- Hybrid",
    "Clinical CBT & REBT in OT Mental Health Practice - 2 day offline course",
    "Clinical Application of Narrative Practice in OT - 2 day offline course",
    "Assistive Technology=1 day Hybrid",
    "Certificate course on Occupational Therapy in NICU- 3 days offline course,",
    "Dysphagia -1 day - Hybrid course",
    "Competency Based Curriculum for OT Education ( only for OT Faculty) -2 day offline workshop",
    "Introduction to DIR and DIR Floortime courses for Paediatric Occupational Therapists . 15 hrs online program byTHE INTERNATIONAL COUNCIL ON DEVELOPMENT AND LEARNING (ICDL)",
  ];

  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    emailAddress: "",
    placeOfWork: "",
    address: "",
    coursePreference: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (error) setError("");
  };

  const handleRadioChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      coursePreference: e.target.value,
    }));
    if (error) setError("");
  };

  const validateForm = () => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!formData.name) {
      return "Name is required.";
    }
    if (!nameRegex.test(formData.name)) {
      return "Name can only contain alphabets and spaces.";
    }

    const phoneRegex = /^\d{10}$/;
    if (!formData.phoneNumber) {
      return "Phone number is required.";
    }
    if (!phoneRegex.test(formData.phoneNumber)) {
      return "Phone number must be exactly 10 digits.";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.emailAddress) {
      return "Email address is required.";
    }
    if (!emailRegex.test(formData.emailAddress)) {
      return "Please enter a valid email address.";
    }

    const placeOfWorkRegex = /^[A-Za-z\s]+$/;
    if (!formData.placeOfWork) {
      return "Place of work is required.";
    }
    if (!placeOfWorkRegex.test(formData.placeOfWork)) {
      return "Place of work can only contain alphabets and spaces.";
    }

    if (!formData.address) {
      return "Address is required.";
    }

    if (!formData.coursePreference) {
      return "Please select a course preference.";
    }

    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      setIsSubmitting(false);
      return;
    }

    try {
      const submitData = {
        coursework: [formData.coursePreference],
        name: formData.name,
        phone_number: formData.phoneNumber,
        email: formData.emailAddress,
        workplace: formData.placeOfWork,
        address: formData.address,
      };

      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/createProfessionalForm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify(submitData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Failed to submit form');
      }

      if (result.success) {
        console.log("Form submitted successfully:", result.data);
        setShowPopup(true);
      } else {
        throw new Error(result.message || 'Form submission failed');
      }
    } catch (err) {
      console.error("Form submission error:", err);
      setError(err.message || 'An error occurred while submitting the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setFormData({
      name: "",
      phoneNumber: "",
      emailAddress: "",
      placeOfWork: "",
      address: "",
      coursePreference: "",
    });
    navigate('/professional-advancement');
  };

  return (
    <>
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      <div className="scrollable-content-home">
        <div className="content-container prof-advance-form-content-container">
          <section className="prof-advance-form-section">
            <Container className="container-prof-advance-form">
              <h2 className="text-center prof-advance-form-heading mb-4">
                Professional Development in Occupational Therapy
              </h2>
              <p className="subtitle-prof-advance-form">
                As a component of the ALL INDIA OCCUPATIONAL THERAPISTS'
                ASSOCIATION'S dedication to facilitating the professional
                advancement of fellow occupational therapists, we have compiled
                a catalogue of courses previously conducted, accessible in both
                online, offline and hybrid formats. Kindly review the list below
                and indicate the courses that align with your career objectives,
                providing your name, email, and phone number. This information
                will assist AIOTA in scheduling these courses periodically,
                contingent upon the availability of resource personnel and other
                essential resources required for the seamless execution of the
                programs.
              </p>

              {error && (
                <Alert variant="danger" className="mb-4">
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <h3 className="mb-3">
                  Coursework Of Preference <span className="required-asterisk">*</span>
                </h3>
                <Form.Group className="mb-4">
                  {courseOptions.map((option) => (
                    <Form.Check
                      key={option}
                      type="radio"
                      className="form-radio-prof-advance-form"
                      id={`course-${option}`}
                      label={option}
                      name="coursePreference"
                      value={option}
                      checked={formData.coursePreference === option}
                      onChange={handleRadioChange}
                      required
                      disabled={isSubmitting}
                    />
                  ))}
                </Form.Group>

                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Group controlId="formName">
                      <Form.Label className="form-label-prof-advance-form">
                        Name <span className="required-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        className="form-control-prof-advance-form"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter your name"
                        required
                        disabled={isSubmitting}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formPhoneNumber">
                      <Form.Label className="form-label-prof-advance-form">
                        Phone Number <span className="required-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        className="form-control-prof-advance-form"
                        type="tel"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        placeholder="Enter your phone number"
                        required
                        disabled={isSubmitting}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Group controlId="formEmailAddress">
                      <Form.Label className="form-label-prof-advance-form">
                        Email Address <span className="required-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        className="form-control-prof-advance-form"
                        type="email"
                        name="emailAddress"
                        value={formData.emailAddress}
                        onChange={handleInputChange}
                        placeholder="Enter your email address"
                        required
                        disabled={isSubmitting}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formPlaceOfWork">
                      <Form.Label className="form-label-prof-advance-form">
                        Place of Work <span className="required-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        className="form-control-prof-advance-form"
                        type="text"
                        name="placeOfWork"
                        value={formData.placeOfWork}
                        onChange={handleInputChange}
                        placeholder="Enter your place of work"
                        required
                        disabled={isSubmitting}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={12}>
                    <Form.Group controlId="formAddress">
                      <Form.Label className="form-label-prof-advance-form">
                        Address <span className="required-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        className="form-control-prof-advance-form"
                        as="textarea"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        placeholder="Enter your address"
                        rows={3}
                        required
                        disabled={isSubmitting}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="text-center">
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className="button-prof-advance-form w-auto"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Form>
            </Container>
          </section>
        </div>
      </div>

      <Modal
        show={showPopup}
        onHide={handleClosePopup}
        centered
        className="prof-advance-form-modal"
      >
        <Modal.Header closeButton className="prof-advance-form-modal-header">
          <Modal.Title className="prof-advance-form-modal-title">
            Submission Successful
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="prof-advance-form-modal-body">
          Thank you for your submission! Your form has been successfully submitted. 
          We will contact you soon regarding the selected course.
        </Modal.Body>
        <Modal.Footer className="prof-advance-form-modal-footer">
          <Button
            variant="primary"
            onClick={handleClosePopup}
            className="prof-advance-form-modal-button"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfessionalAdvancementForm;